import { AppService } from "app/services/app.service";


export abstract class AbControlePrevisaoVisita extends AppService {
  abstract getControlePrevisaoVisita();
  abstract salvarControlePrevisaoVisita(controlePrevisaoVisita);
}